import { Injectable } from '@angular/core';
import { NgxMatNativeDateAdapter } from '@angular-material-components/datetime-picker';

@Injectable()
export class CustomDateAdapter extends NgxMatNativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1; // 0 = Dimanche, 1 = Lundi
  }
}